var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLineheightDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9609 22.5C11.6875 22.5 11.4531 22.3828 11.2578 22.1875L7.50781 18.125C7.35156 17.9297 7.27344 17.6953 7.27344 17.5C7.27344 17.2266 7.35156 16.9922 7.54688 16.7969C7.9375 16.4453 8.52344 16.4844 8.875 16.8359L11.0234 19.1406V5.85938L8.91406 8.16406C8.5625 8.51562 7.97656 8.55469 7.58594 8.20312C7.39062 8.00781 7.27344 7.77344 7.27344 7.5C7.27344 7.26562 7.39062 7.03125 7.54688 6.83594L11.2969 2.77344C11.4531 2.57812 11.7266 2.5 11.9609 2.5C12.2344 2.5 12.5078 2.57812 12.6641 2.77344L16.4141 6.83594C16.7656 7.22656 16.7266 7.8125 16.375 8.16406C15.9844 8.51562 15.3984 8.51562 15.0469 8.125L12.8984 5.82031V19.1406L15.0469 16.8359C15.3984 16.4844 15.9844 16.4453 16.375 16.7969C16.7266 17.1484 16.7656 17.7344 16.4141 18.125L12.6641 22.1875C12.5078 22.4219 12.2344 22.5 11.9609 22.5Z",
    fill: "#313C59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9551 13.3271V11.4062H20.7285V13.3271H16.9551Z",
    fill: "#313C59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLineheightDown);
export default __webpack_public_path__ + "static/media/ic_lineheight-down.9fda449308721f6e5f92df5bbe1479d3.svg";
export { ForwardRef as ReactComponent };